import { useState, type FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { pb } from './lib/pb';
import { errorMessage } from './lib/errors';
import { setLanguage } from './i18n';
import type { UserRecord } from './lib/types';

export function Login() {
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const res = await pb.collection('users').authWithPassword<UserRecord>(email.trim(), password);
      if (res.record.lang) setLanguage(res.record.lang);
    } catch (err) {
      setError(errorMessage(err) || t('login.failed'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login">
      <form className="login-card" onSubmit={submit}>
        <h1>{t('app.title')}</h1>
        <p className="muted">{t('app.subtitle')}</p>
        <label>
          {t('login.email')}
          <input
            type="email"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
          />
        </label>
        <label>
          {t('login.password')}
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>
        {error && <div className="error">{error}</div>}
        <button className="primary" disabled={busy}>
          {t('login.submit')}
        </button>
        <p className="muted small">{t('login.hint')}</p>
        <div className="lang-switch">
          {(['sv', 'en'] as const).map((l) => (
            <button
              type="button"
              key={l}
              className={i18n.language === l ? 'active' : ''}
              onClick={() => setLanguage(l)}
            >
              {l.toUpperCase()}
            </button>
          ))}
        </div>
      </form>
    </div>
  );
}
